// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"34223":"commons","36209":"ui","72213":"sbanken","91336":"eiendom"}[chunkId] + "." + {"34223":"18c273f18b4130b1fe20","36209":"39019699a28fa4a631d0","72213":"e96dee7403ca8f7fa82c","91336":"2fd8982a7c0394367514"}[chunkId] + ".css";
};